import './App.css';
import { Box, Container, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CardBanner from './components/Card/CardBanner';
import MainButton from './components/MainButton/MainButton';
import Footer from './components/Footer/Footer';
import MobileContext from './context/MobileContext';
import listOfLink from './util/linkList';

function App() {
    
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));
    return <MobileContext.Provider value={mobile}>
    <Box sx={{backgroundImage: 'url(img/bg.JPG)', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundSize: 'cover', backgroundPosition: 'right'}}>
        <Box sx={{display: 'block', width: '100%'}}>
            <Box className="header" sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '1rem'
            }}>
                <Box sx={{alignItems: 'center', justifyContent: 'center', display:'flex', width: '100%'}}>
                    <Box display='block' sx={{textAlign: 'center', color: 'black'}}>
                        <Box className="logo" sx={{marginBottom: '0.5rem'}}>
                            <img src="/img/main_logo_white_bg.JPG" alt="logo" style={{height: '5rem', marginRight: '1rem', borderRadius: '1rem'}}></img>
                        </Box>
                        <Box sx={{color: '#646548'}}>
                            <Typography variant='h5' sx={{lineHeight: 1}}>PUSAT STUDI</Typography>
                            <Typography variant='h5' sx={{lineHeight: 1, fontWeight: 600}}>KEPABEANAN DAN CUKAI</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Container sx={{backgroundColor: 'rgba(255,255,255,0.9)', marginY: 'auto', paddingY: '1rem', borderRadius: '1rem'}}>
                <Box className="event">
                    <CardBanner imgUrl="/event_bg.png" bgColor="#55a8b3">
                            <Box sx={{marginLeft: '2rem', maxWidth: '50%', color: 'white'}}>
                                <Typography variant={mobile ? "h5" : "h3"} sx={{lineHeight: 1, textAlign: 'left'}}><b>CUSTOMS CLASS III</b></Typography>
                                <Typography variant={mobile ? "subtitle2" : "h5"} sx={{lineHeight: 1, textAlign: 'left'}}><b>PUBLIC POLICY</b></Typography>
                            </Box>
                    </CardBanner>
                </Box>
                <Box className="link-btn" sx={{marginTop: '1rem'}}>
                    <Stack gap='1rem'>
                        {listOfLink.map((menu) => (menu.active && 
                            <MainButton url={menu.url}>
                                {menu.title.toUpperCase()}
                            </MainButton>
                        ))}
                    </Stack>
                </Box>
            </Container>
        </Box>
    </Box>
    <Footer />
    </MobileContext.Provider>
}

export default App;
